var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKeyboardArrowRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7018 17.7018L15.7018 12.7018C15.8947 12.5263 16 12.2807 16 12C16 11.4561 15.5439 11 15 11C14.7193 11 14.4737 11.1053 14.2982 11.2982L9.29825 16.2982C9.10526 16.4737 9 16.7193 9 17C9 17.5439 9.45614 18 10 18C10.2807 18 10.5263 17.8947 10.7018 17.7018ZM15.7018 11.2982L10.7018 6.29825C10.5263 6.10526 10.2807 6 10 6C9.45614 6 9 6.45614 9 7C9 7.2807 9.10526 7.52632 9.29825 7.70175L14.2982 12.7018C14.4737 12.8947 14.7193 13 15 13C15.5439 13 16 12.5439 16 12C16 11.7193 15.8947 11.4737 15.7018 11.2982Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyboardArrowRight);
export default __webpack_public_path__ + "static/media/keyboard_arrow_right.10498b91.svg";
export { ForwardRef as ReactComponent };